<template>
    <tree-select
      ref="treeSelect"
      :props="props"
      :options="data"
      :value="value1"
      :parent-select="pSelect"
      :clearable="false"
      placeholder="请选择"
      @node-select="select($event)"
      :disabled="disabledStatus==2"
    />
  </template>
  <script>
  import treeSelect from "@/components/common/treeSelect";
  export default {
    components: { treeSelect },
    props: {
      value: {},
      pSelect: {
        type: Boolean,
        default: true,
      },
      disabledStatus:{
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        api: require("@/api/ba/class").default,
        value1: null,
        data: [],
        props: {
          // 配置项（必选）
          value: "ClassId",
          label: "ClassName",
          children: "children",
        },
      };
    },
    mounted() {
      this.value1 = this.value;
      console.log("mounted", this.value1);
      this.init();
    },
    watch: {
      value() {
        this.value1 = this.value;
        console.log("watch", this.value1);
      },
    },
    methods: {
      init(params = {}) {
        params = { ...params, ClassType: 16 };
        console.log("init", params);
        this.api.list(params).then((res) => {
          this.data = this.$commonJs.toTreeData(res.Data, "ClassId")[1].children;
          this.$refs.treeSelect.setData();
        });
      },
      clear() {
        this.$refs.treeSelect.clearHandle();
      },
      select(e) {
        if (e) this.$emit("input", e.ClassId);
        else this.$emit("input", null);
      },
    },
  };
  </script>